import {put, takeLatest, call} from 'redux-saga/effects';
import * as productService from "../../../../services/productService";
import {
    UPDATE_PRODUCT,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_ERROR,
}
    from "../../../actions/menu/products";

function* updateProductSaga(action) {
    try {
        const data = yield call(productService.UpdateProduct, action.payload)
        yield put({
            type: UPDATE_PRODUCT_SUCCESS,
            payload: {...data, productType : action.payload.payload.productType}
        });


    } catch (error) {
        yield put({
            type: UPDATE_PRODUCT_ERROR,error: error.data
        });
    }
}


export function* updateProductSagaWatcher() {
    yield takeLatest(UPDATE_PRODUCT, updateProductSaga);
}